const FADE_OUT_DELAY = 10000; //ms
const FADE_IN_EVENTS = [
    "mousemove",
    "click",
    "touchstart",
    "touchmove",
    "keydown",
];

class FadeInOut {
    constructor(element, fadeOutCssClass) {
        this._element = element;
        this._fadeOutClass = fadeOutCssClass;
        this._fadeInAndResetTimer = this._fadeInAndResetTimer.bind(this);
    }

    initialize() {
        this._fadeInAndResetTimer();
        FADE_IN_EVENTS.forEach((eventName) => {
            this._element.addEventListener(
                eventName,
                this._fadeInAndResetTimer,
                true
            );
        });
    }

    dispose() {
        this._fadeIn();
        this._clearTimer();
        FADE_IN_EVENTS.forEach((eventName) => {
            this._element.removeEventListener(
                eventName,
                this._fadeInAndResetTimer,
                true
            );
        });
    }

    _fadeInAndResetTimer() {
        this._fadeIn();
        this._clearTimer();
        this._fadeOutTimerId = window.setTimeout(() => {
            this._element.classList.add(this._fadeOutClass);
            this._fadeOutTimerId = null;
        }, FADE_OUT_DELAY);
    }

    _fadeIn() {
        this._element.classList.remove(this._fadeOutClass);
    }

    _clearTimer() {
        if (this._fadeOutTimerId) {
            window.clearTimeout(this._fadeOutTimerId);
            this._fadeOutTimerId = null;
        }
    }
}

export default FadeInOut;
